:root {
  --tooltip-bg: var(--L2-BG);
  --tooltip-text: var(--TEXT-PRIMARY);
  --tooltip-border: color-mix(in srgb, var(--MAIN-BORDER-COLOR) 75%, transparent);
  --tooltip-shadow: var(--CHROME-ELEVATION-SHADOW-SM, 0 8px 24px rgba(0, 0, 0, 0.28));

  --popover-bg: var(--L2-BG);
  --popover-text: var(--TEXT-PRIMARY);
  --popover-border: color-mix(in srgb, var(--MAIN-BORDER-COLOR) 75%, transparent);
  --popover-shadow: var(--CHROME-ELEVATION-SHADOW-MD, 0 12px 32px rgba(0, 0, 0, 0.35));

  --popover-radius: 10px;
  --tooltip-radius: 8px;

  --chart-tooltip-bg: var(--L2-BG);
  --chart-tooltip-text: var(--TEXT-PRIMARY);
  --chart-tooltip-border: color-mix(in srgb, var(--MAIN-BORDER-COLOR) 80%, transparent);
}

/* ========== LEGACY ID HOOKS ========== */
#popover-basic {
  background-color: var(--popover-bg);
  color: var(--popover-text);
}
#tooltip-top {
  background-color: transparent;
  color: var(--tooltip-text);
}

/* ========== TOOLTIP ========== */
.tooltip,
.tooltip .tooltip-inner {
  background-color: var(--tooltip-bg);
  color: var(--tooltip-text);
  border: 1px solid var(--tooltip-border);
  border-radius: var(--tooltip-radius);
  box-shadow: var(--tooltip-shadow);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.4;
  padding: 0.4rem 0.65rem;
  max-width: 260px;
}

.tooltip .tooltip-inner {
  border: 0;
  box-shadow: none;
  padding: 0;
  background: transparent;
}

.tooltip.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: var(--tooltip-bg);
}
.tooltip.bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: var(--tooltip-bg);
}
.tooltip.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: var(--tooltip-bg);
}
.tooltip.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: var(--tooltip-bg);
}

/* ========== POPOVER (help + general) ========== */
.popover {
  --bs-popover-bg: var(--popover-bg);
  --bs-popover-border-color: var(--popover-border);
  background-color: var(--popover-bg);
  color: var(--popover-text);
  border: 1px solid var(--popover-border) !important;
  border-radius: var(--popover-radius) !important;
  box-shadow: var(--popover-shadow);
  width: auto !important;
  max-width: 280px;
  padding: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  z-index: 1080;
}

.popover.bs-popover-top .popover-arrow::after {
  border-top-color: var(--popover-bg);
}
.popover.bs-popover-bottom .popover-arrow::after {
  border-bottom-color: var(--popover-bg);
}
.popover.bs-popover-start .popover-arrow::after {
  border-left-color: var(--popover-bg);
}
.popover.bs-popover-end .popover-arrow::after {
  border-right-color: var(--popover-bg);
}

.popover.bs-popover-top .popover-arrow::before {
  border-top-color: var(--popover-border);
}
.popover.bs-popover-bottom .popover-arrow::before {
  border-bottom-color: var(--popover-border);
}
.popover.bs-popover-start .popover-arrow::before {
  border-left-color: var(--popover-border);
}
.popover.bs-popover-end .popover-arrow::before {
  border-right-color: var(--popover-border);
}

.popover-header,
.popover-body {
  background-color: transparent;
  color: inherit;
  border: 0;
  padding: 0;
}

.popover_body {
  max-height: min(50vh, 320px);
  overflow-y: auto;
  padding: 0.75rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 450;
  line-height: 1.45;
  color: color-mix(in srgb, var(--popover-text) 92%, transparent);
}

.popover_body p {
  margin: 0 0 0.35rem;
}

.popover_body p:last-child {
  margin-bottom: 0;
}

.popover_body strong {
  color: var(--popover-text);
  font-weight: 600;
}

.popover_long {
  max-width: 420px;
}

/* ========== CHART TOOLTIP ========== */
.popover.chart-tooltip {
  background-color: var(--chart-tooltip-bg) !important;
  color: var(--chart-tooltip-text) !important;
  border: 1px solid var(--chart-tooltip-border) !important;
  width: auto !important;
  max-width: 180px;
  font-size: 0.6875rem !important;
  border-radius: 8px !important;
  box-shadow: var(--popover-shadow);
}

.popover.chart-tooltip.bs-popover-top .popover-arrow::after {
  border-top-color: var(--chart-tooltip-bg);
}
.popover.chart-tooltip.bs-popover-bottom .popover-arrow::after {
  border-bottom-color: var(--chart-tooltip-bg);
}
.popover.chart-tooltip.bs-popover-start .popover-arrow::after {
  border-left-color: var(--chart-tooltip-bg);
}
.popover.chart-tooltip.bs-popover-end .popover-arrow::after {
  border-right-color: var(--chart-tooltip-bg);
}

.tooltip-target {
  display: inline-block;
  width: 100%;
}
